import React from "react";
import styled from "styled-components";

// import { BhLogin } from "../../DivWrapperScreen/login/login";

const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;

& .button-container {
    display: flex;
    position: absolute;
    justify-content: center;
    gap: 24px;
    top: 215px;
    width: 100%;
    height: 264px;
}

& .button-image {
    width: 384px;
    height: 264px;
}


`;


export const BhHomepage11 = () => {
    return (
        <StyledElement>
            <img className="background-image" alt="background-image" src="/image/11page 고객센터.png" />

            <div className="button-container">
                <a href="http://pf.kakao.com/_hlxnjG" target="_blank" rel="noopener noreferrer">
                    <img className="button-image" alt="kakao" src="/image/11page_카카오톡.png" />
                </a>

                <img className="button-image" alt="kakao" src="/image/11page_전화상담.png" />
                <img className="button-image" alt="kakao" src="/image/11page_이메일.png" />
            </div>
        </StyledElement>
    );
};
